module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-provide', {
    attrs: {
      "product": _vm.product,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingAttributes || _vm.loadingCategories
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('warrantyTime.label'),
      "columns": 3,
      "error": _vm.getError('warrantyTime', _vm.product.productId),
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.warrantyTime),
      expression: "product.warrantyTime"
    }],
    staticClass: "form-input",
    attrs: {
      "disabled": _vm.disabledInputs(),
      "required": true,
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.warrantyTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "warrantyTime", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("meses")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.brand),
      expression: "product.brand"
    }],
    staticClass: "form-input",
    attrs: {
      "slot": "brands",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.product.brand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "brand", $event.target.value)
      }
    },
    slot: "brands"
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('department.label'),
      "columns": 3,
      "error": _vm.getError('department', _vm.product.productId),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.departments,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha",
      "label": "label",
      "track-by": "code"
    },
    model: {
      value: (_vm.department),
      callback: function($$v) {
        _vm.department = $$v
      },
      expression: "department"
    }
  })], 1), _vm._v(" "), (_vm.categories.length) ? _c('form-group', {
    attrs: {
      "label": _vm.$t('category.label'),
      "columns": 3,
      "error": _vm.getError('category', _vm.product.productId),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.categories,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha",
      "label": "label",
      "track-by": "code"
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.product.category) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.attributes), function(attribute, index) {
    return _c('form-group', {
      key: attribute.id,
      attrs: {
        "label": attribute.name,
        "columns": 3,
        "error": _vm.getError(attribute.id, _vm.product.productId),
        "required": attribute.required
      }
    }, [(attribute.type === 'MVU') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-select",
      attrs: {
        "disabled": _vm.disabledInputs()
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(attribute, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((attribute.values), function(option) {
      return _c('option', {
        domProps: {
          "value": option.text
        }
      }, [_vm._v(_vm._s(option.text))])
    })], 2) : (attribute.type === 'MVM' && attribute.multiselect) ? _c('multiselect', {
      attrs: {
        "label": "text",
        "track-by": "id",
        "options": attribute.values,
        "multiple": true,
        "selectLabel": "Clique",
        "selectedLabel": "Selecionado",
        "placeholder": "Selecione a opção"
      },
      model: {
        value: (attribute.value),
        callback: function($$v) {
          _vm.$set(attribute, "value", $$v)
        },
        expression: "attribute.value"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c18d56b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/cnova/provide/Product.vue
// module id = 3017
// module chunks = 0